"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const nmr_processing_1 = require("nmr-processing");
const react_1 = require("react");
const Yup = __importStar(require("yup"));
const DefaultApodizationOptions_1 = require("../../data/constants/DefaultApodizationOptions");
const DispatchContext_1 = require("../context/DispatchContext");
const ActionButtons_1 = __importDefault(require("../elements/ActionButtons"));
const Label_1 = __importDefault(require("../elements/Label"));
const FormikCheckBox_1 = __importDefault(require("../elements/formik/FormikCheckBox"));
const FormikInput_1 = __importDefault(require("../elements/formik/FormikInput"));
const FormikOnChange_1 = __importDefault(require("../elements/formik/FormikOnChange"));
const useFilter_1 = require("../hooks/useFilter");
const Header_1 = require("./Header");
const HeaderContainer_1 = require("./HeaderContainer");
const inputStyle = {
    input: { width: '60px', textAlign: 'center' },
    inputWrapper: { height: '100%' },
};
const validationSchema = Yup.object().shape({
    lineBroadening: Yup.number().required(),
    gaussBroadening: Yup.number().required(),
    lineBroadeningCenter: Yup.number().required().min(0).max(1),
});
const initialValues = {
    ...DefaultApodizationOptions_1.defaultApodizationOptions,
    livePreview: true,
};
function ApodizationOptionsInnerPanel(props) {
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const previousPreviewRef = (0, react_1.useRef)(initialValues.livePreview);
    function handleApplyFilter(values, triggerSource = 'apply') {
        const { livePreview, ...options } = values;
        switch (triggerSource) {
            case 'onChange': {
                if (livePreview || previousPreviewRef.current !== livePreview) {
                    dispatch({
                        type: 'CALCULATE_APODIZATION_FILTER',
                        payload: { livePreview, options },
                    });
                }
                break;
            }
            case 'apply': {
                dispatch({
                    type: 'APPLY_APODIZATION_FILTER',
                    payload: { options },
                });
                break;
            }
            default:
                break;
        }
        previousPreviewRef.current = livePreview;
    }
    function handleCancelFilter() {
        dispatch({
            type: 'RESET_SELECTED_TOOL',
        });
    }
    let formData = initialValues;
    if (props.filter) {
        formData = { ...initialValues, ...props.filter.value, livePreview: true };
    }
    return ((0, jsx_runtime_1.jsx)(HeaderContainer_1.HeaderContainer, { children: (0, jsx_runtime_1.jsx)(formik_1.Formik, { onSubmit: (values) => handleApplyFilter(values), initialValues: formData, validationSchema: validationSchema, children: ({ submitForm }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Label_1.default, { title: "Line broadening : ", shortTitle: "LB :", style: Header_1.headerLabelStyle, children: (0, jsx_runtime_1.jsx)(FormikInput_1.default, { type: "number", name: "lineBroadening", min: 0, max: 1, step: 0.1, style: inputStyle, debounceTime: 250 }) }), (0, jsx_runtime_1.jsx)(Label_1.default, { title: "Gauss broadening :", shortTitle: "GB :", style: Header_1.headerLabelStyle, children: (0, jsx_runtime_1.jsx)(FormikInput_1.default, { type: "number", name: "gaussBroadening", min: 0, max: 1, step: 0.1, style: inputStyle, debounceTime: 250 }) }), (0, jsx_runtime_1.jsx)(Label_1.default, { title: "lineBroadeningCenter [0 - 1] : ", shortTitle: "LB Center :", style: Header_1.headerLabelStyle, children: (0, jsx_runtime_1.jsx)(FormikInput_1.default, { type: "number", name: "lineBroadeningCenter", min: 0, max: 1, step: 0.1, style: inputStyle, debounceTime: 250 }) }), (0, jsx_runtime_1.jsx)(Label_1.default, { title: "Live preview ", htmlFor: "livePreview", style: { label: { padding: '0 5px' } }, children: (0, jsx_runtime_1.jsx)(FormikCheckBox_1.default, { name: "livePreview" }) }), (0, jsx_runtime_1.jsx)(FormikOnChange_1.default, { onChange: (values) => handleApplyFilter(values, 'onChange'), enableOnload: true }), (0, jsx_runtime_1.jsx)(ActionButtons_1.default, { onDone: submitForm, onCancel: handleCancelFilter })] })) }) }));
}
const MemoizedApodizationPanel = (0, react_1.memo)(ApodizationOptionsInnerPanel);
function ApodizationOptionsPanel() {
    const filter = (0, useFilter_1.useFilter)(nmr_processing_1.Filters.apodization.id);
    return (0, jsx_runtime_1.jsx)(MemoizedApodizationPanel, { filter: filter });
}
exports.default = ApodizationOptionsPanel;
